export default "__VITE_ASSET__DPP7uknw__"